module.exports = __webpack_public_path__ + "static/media/Italy_scooter.fccc5a53.jpg";